<template>
  <div class="px-4 py-8 w-full min-h-screen" v-loading="loading"
       element-loading-text="Loading..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <CustomerChartsComponent />
  </div>
</template>

<script>
import CustomerChartsComponent from '../components/CustomerCharts.vue';

export default {
  name: 'CustomerCharts',
  components: {
    CustomerChartsComponent,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async fetchAllData() {
      try {
        this.loading = true;
        await this.$store.dispatch('AICustomers/fetchRfmCounts');

        this.loading = false;
      } catch (e) {
        this.loading = false;
      }

      this.loading = false;
    },
  },
  async mounted() {
    await this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    await this.fetchAllData();
  },
};
</script>
